import api_call_v2 from "utils/API_CALL/api_call_v2";
import PROXY_CONFIG from "../../Config/ProxyConfig";

const GetDataFromLatLng = async (lat, lng, type = "quartier") => {
  return new Promise((resolve, reject) => {
    
      api_call_v2(
        undefined,
        "post",
        "prix-immobilier/rgc",
        {
          lat: lat,
          lng: lng,
          collection: type,
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {

        reject(err);
      });
  });
};

export default GetDataFromLatLng;
